import { createContext, useContext } from 'react';
import type { GamesApiAdapter } from './api';
import type { GamesCapabilities } from './capabilities';

export interface GamesUser {
  id: string;
  developerCompanyName?: string;
}

export interface GamesModule {
  api: GamesApiAdapter;
  capabilities: GamesCapabilities;
  currentUser: GamesUser | null;
  navigateToGames(): void;
  reportError(error: unknown, context?: string): void;
}

export const GamesModuleContext = createContext<GamesModule | null>(null);

export function useGamesModule(): GamesModule {
  const module = useContext(GamesModuleContext);
  if (!module) {
    throw new Error('Game views must be rendered inside GamesProvider');
  }
  return module;
}
